import { h, Component } from 'preact';
import { joinClasses, debounce } from 'utils/utils';
import HTML from 'components/core/html/html';
import s from 'components/bolt/tooltip/tooltip.sss';

export default class Tooltip extends Component {
	constructor(props) {
		super(props);
		this.toggleTooltip = this.toggleTooltip.bind(this);
		this.debouncedHideTooltip = debounce(this.debouncedHideTooltip.bind(this), props.selfHideMilliseconds);
		this.state = {
			displayTooltip: this.props.isOpen ? true : false
		};
	}

	debouncedHideTooltip() {
		this.setState({ displayTooltip: false });
	}


	toggleTooltip () {
		const displayTooltip = this.state.displayTooltip;

		if (this.props.showCondition !== undefined && this.props.selfHideMilliseconds) {
			this.debouncedHideTooltip();
		}

		if (displayTooltip === true && this.props.showCondition !== undefined) {
			if (this.props.showCondition === true) {
				if (!this.shouldHide) {
					this.$bubble.style.display = 'block';
				} else {
					this.shouldHide = false;
				}
			}
		} else if (displayTooltip === false && this.props.showCondition !== undefined) {
			if (this.props.showCondition === true) {
				if (!this.shouldHide) {
					this.setState({ displayTooltip: true });
				}
				this.shouldHide = false;
			}
		} else {
			this.setState({ displayTooltip: !displayTooltip });
		}

		(displayTooltip && this.props.onHide) && this.props.onHide();
		(!displayTooltip && this.props.onShow) && this.props.onShow();
	}

	componentDidUpdate(prevProps) {
		const currentStageIndex = this.props.stageIndex;
		const prevStageIndex = prevProps.stageIndex;

		if (currentStageIndex && currentStageIndex !== prevStageIndex) {
			this.shouldHide = true;
			// this.setState({ displayTooltip: true }, () => {
			// 	this.$bubble.style.display = 'none';
			// });

			// if (this.$bubble) this.$bubble.style.display = 'none';
			// this.setState({ displayTooltip: false });
		}
	}

	componentWillUpdate(prevProps) {
		const nowSelfTriggerCondition = this.props.showCondition;
		const prevSelfTriggetCondition = prevProps.showCondition;

		const currentStageIndex = this.props.stageIndex;
		const prevStageIndex = prevProps.stageIndex;

		if (currentStageIndex && currentStageIndex !== prevStageIndex) {
			if (this.$bubble) this.$bubble.style.display = 'none';
		}

		if (nowSelfTriggerCondition !== undefined && nowSelfTriggerCondition !== prevSelfTriggetCondition && nowSelfTriggerCondition === true) {
			if (this.$bubble) {
				if (this.$bubble) this.$bubble.style.display = 'none';
			}
		}
	}

	render() {
		const { data, position, class: extraClass, isMobile, id, icon } = this.props;
		const { title, content, buttonTooltip } = data;
		const displayTooltip = this.state.displayTooltip;

		return (
			<div>
				{(displayTooltip && isMobile) && <div className={s.overlay} />}
				<div id={id} className={joinClasses(s.tooltip, isMobile && s.mobileTooltip )}>
					{this.state.displayTooltip && (
						<div className={joinClasses(s.bubble, s[position])} ref={e => this.$bubble = e} style={{}}>
							<div className={joinClasses(s.message, extraClass && extraClass)}>
								{icon && <div className={s.icon}>{icon}</div>}
								{title && <HTML tag="div" markdown class={s.title} style={{ marginBottom: content ? '16px' : '0' }} content={title} />}
								{content && <HTML tag="div" markdown class={s.content} style={{ marginBottom: buttonTooltip ? '16px' : '0' }} content={content} />}
								{(isMobile && buttonTooltip) && <button className={s.close} onClick={this.toggleTooltip}>{buttonTooltip}</button>}
							</div>
						</div>
					)}
					<span className={s.trigger} onClick={this.toggleTooltip}>
						{this.props.children}
					</span>
				</div>
			</div>
		);
	}
}
